/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useProfileLayoutStyles = makeStyles(() => ({
  pageTitle: {
    margin: '0',
    marginLeft: '15px',
  },
  tabsRoot: {
    marginBottom: '40px',
  },
  profileTitle: {
    margin: '20px 0 40px',
    display: 'flex',
    alignItems: 'center',
  },
  profilePhoto: {
    borderRadius: '50%',
  },
  deleteIcon: {
    background: '#ECEBED',
    // marginLeft: "10px",
  },
}));
